import { gql } from "@apollo/client";

const NOTIFICATION_SETTINGS_FIELDS = `
  purchaseUpdates
  lowBalanceWarnings
  discordLinked
`;

export const GET_MY_NOTIFICATION_SETTINGS = gql`
  query getMyNotificationSettings {
    getMyNotificationSettings {
      ${NOTIFICATION_SETTINGS_FIELDS}
    }
  }
`;

export const SET_MY_NOTIFICATION_SETTINGS = gql`
  mutation setMyNotificationSettings(
    $purchaseUpdates: Boolean
    $lowBalanceWarnings: Boolean
  ) {
    setMyNotificationSettings(
      purchaseUpdates: $purchaseUpdates
      lowBalanceWarnings: $lowBalanceWarnings
    ) {
      ${NOTIFICATION_SETTINGS_FIELDS}
    }
  }
`;
